<template>
  <div class="hm-transfer">
    <div class="flex item-center">
      <!-- 左边 -->
      <div class="table">
        <div class="table-out-header flex flex-between">
          <div class="tranfer-checkbox-wrapper">
            <el-checkbox
              :indeterminate="leftIsIndeterminate"
              :disabled="leftData.length <= 0"
              v-model="leftCheckAll"
              @change="handleLeftCheckAllChange"
            >
              <span class="check-all">全选</span>
            </el-checkbox>
          </div>
          <div class="transfer-title flex-2 text-center">{{ leftName }}</div>
          <div class="transfer-title text-right">共{{ leftData.length }}条</div>
        </div>
        <div class="table-header flex flex-between">
          <el-input
            size="small"
            placeholder="请输入品牌/商品名称/条码搜索"
            suffix-icon="el-icon-search"
            clearable
            @input="handleSearchLeft"
            v-model="searchLeft" style="width: 100%;">
          </el-input>
        </div>
        <div class="table-body">
          <el-scrollbar
            ref="scrollContainer"
            :vertical="false"
            wrap-style="height: 500px;"
          >
            <el-checkbox-group
              :disabled="disabled"
              v-model="leftChecked"
              @change="handleLeftCheckedChange"
            >
              <div
                v-for="(v, i) in leftData"
                :key="i"
                class="check-wrapper flex item-center"
                :title="v.attrValue"
              >
                <div class="flex-3">
                  <el-checkbox :label="v" class="flex item-center">
                    <p class="flex" style="width: 100%; justify-content: space-around;gap: 20px;">
                      <span>{{v.brandName}}</span>
                      <span>{{v.goodsName}}</span>
                      <span>{{v.goodsBarcode}}</span>
                   </p>
                  </el-checkbox>
                </div>
              </div>
            </el-checkbox-group>
          </el-scrollbar>
        </div>
      </div>
      <!-- 按钮 --> 
      <div class="flex flex-column control text-center">
        <div class="mb20">操作</div>
        <!-- <el-switch
          v-model="isMustDelivery"
          v-if="showMustDelivery"
          size="mini"
          active-color="#13ce66"
          inactive-color="#ff4949"
          active-value="yes"
          active-text="必选"
          inactive-text="可选"
          inactive-value="no"
        >
        </el-switch> -->
        <el-switch
          size="mini"
          class="transfer-switch"
          v-if="showUseable"
          v-model="whitelistState"
          :disabled="disabled"
          active-text="黑名单"
          inactive-text="白名单"
          active-value="black"
          inactive-value="white"
        ></el-switch>
        <el-button
          size="small"
          class="hmicon icon-youshuangjiantou1"
          @click="allToRight"
          :disabled="leftData.length <= 0 || disabled"
        ></el-button>
        <el-button
          size="small"
          class="hmicon icon-youjiantou"
          @click="toRight"
          :disabled="
            leftData.length <= 0 || leftChecked.length <= 0 || disabled
          "
        ></el-button>
        <el-button
          size="small"
          class="hmicon icon-zuoshuangjiantou1"
          @click="allToLeft"
          :disabled="rightData.length <= 0 || disabled"
        ></el-button>
        <el-button
          size="small"
          class="hmicon icon-zuojiantou"
          @click="toLeft"
          :disabled="
            rightData.length <= 0 || rightChecked.length <= 0 || disabled
          "
        ></el-button>
        <el-button
          size="small"
          class="hmicon icon-zuojiantou delete-selected"
          @click="deleteChecked"
          :disabled="
            leftChecked.length <= 0 || rightData.length <= 0 || disabled
          "
        >
          剔除
          <el-tooltip
            class="item"
            effect="dark"
            content="剔除右侧列表和左侧已勾选的相同的选项"
            placement="top-end"
          >
            <i class="hmicon icon-wenhao"></i>
          </el-tooltip>
        </el-button>
      </div>
      <!-- 右边 -->
      <div class="table">
        <div class="table-out-header flex flex-between">
          <div class="tranfer-checkbox-wrapper">
            <el-checkbox
              :indeterminate="rightIsIndeterminate"
              :disabled="rightData.length <= 0 || disabled"
              v-model="rightCheckAll"
              @change="handleRightCheckAllChange"
            >
              <span class="check-all">全选</span>
            </el-checkbox>
          </div>
          <div class="transfer-title flex-2 text-center">{{ rightName }}</div>
          <div class="transfer-title text-right">共{{ rightData.length }}条</div>
        </div>
        <div class="table-header flex flex-between">
          <el-input
            size="small"
            placeholder="请输入品牌/商品名称/条码搜索"
            suffix-icon="el-icon-search"
            @input="handleSearchRight"
            clearable
            v-model="searchRight" style="width: 100%;">
          </el-input>
        </div>
        <div class="table-body">
          <el-scrollbar
            ref="scrollContainer"
            :vertical="false"
            wrap-style="height: 500px;"
          >
            <el-checkbox-group
              v-model="rightChecked"
              @change="handleRightCheckedChange"
              :disabled="disabled"
            >
              <draggable :list="rightData">
                <div
                  v-for="(v, i) in rightData"
                  :key="i"
                  class="check-wrapper item-center"
                >
                  <div class="flex">
                    <el-checkbox :label="v" class="flex item-center">
                      <p class="flex" style="width: 100%; justify-content: space-around;gap: 20px;">
                        <span>{{v.brandName}}</span>
                        <span>{{v.goodsName}}</span>
                        <span>{{v.goodsBarcode}}</span>
                      </p>
                    </el-checkbox>
                  </div>
                </div>
              </draggable>
            </el-checkbox-group>
          </el-scrollbar>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="errValidGoods" width="30%" title="提示">
      <div>
        <div>
          您有
          <span class="error">{{ errInputResult.length }}</span
          >条数据有误未导入
        </div>
        <el-table :data="errInputResult" border class="small-table">
          <el-table-column prop="goodsBarcode" label="错误货号">
            <template slot-scope="scope">
              {{ scope.row }}
            </template>
          </el-table-column>
          <!-- <el-table-column prop="mobile" label="手机号"></el-table-column> -->
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { arrayUnique2 } from "@/utils/utils";
import draggable from "vuedraggable";

export default {
  components: { draggable },
  props: {
    showUseable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isVouchers: {
      type: Boolean,
      default: false
    },
    showAttribute: {
      type: Boolean,
      default: false
    },
    onlySelectGoods: {
      type: Boolean,
      default: false
    },
    showMustDelivery: {
      type: Boolean,
      default: false
    },
    leftProps: {
      type: Array,
      default: () => []
    },
    rightProps: {
      type: Array,
      default: () => []
    },
    compareKey: {
      type: String,
      default: ""
    },
    leftName: { type: String },
    rightName: { type: String },
    leftOption: { type: Array },
    rightOption: { type: Array },
    queryIsUsed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchLeft: "",
      searchRight: "",
      errInputResult: [],
      errValidGoods: false,
      whitelistState: "white",
      isCheckedAttribute: false,
      isMustDelivery: false,
      catId: "",
      brandId: "",
      goodsName: "",
      categoryList: [],
      brandList: [],
      leftCheckAll: false,
      leftChecked: [],
      leftData: [],
      storageDateLeft: [],
      storageDateRight:[],
      leftIsIndeterminate: false,
      rightCheckAll: false,
      rightChecked: [],
      rightData: [],
      rightIsIndeterminate: false,
      isEnableSession: false,
      sendWayType: "",
      isChecked: false
    };
  },
  computed: mapGetters([
    "offlineGoodsListResult",
    "offlineBrandList",
    "crossQueryResult"
  ]),
  watch: {
   
    showUseable(val) {
      if (val) {
        this.whitelistState = "white";
      }
    },
    crossQueryResult(val) {
      if (val.length) {
        this.leftData = val;
        this.leftData.forEach(v => {
          v.goodsPackageNum = 1;
          if (v.goodsName) {
            v.goodsInfo = v.goodsName;
          }
        });
      } else {
        this.leftData = [];
      }
    },
    offlineGoodsListResult(val) {
      if (val.length) {
        this.leftData = val;
        this.leftData.forEach(v => {
          v.goodsPackageNum = 1;
          if (v.goodsName) {
            v.goodsInfo = v.goodsName;
          }
        });
      } else {
        this.leftData = [];
      }
    },
    leftOption: {
      handler(newVal) {
        console.log('---leftData---', newVal, this.leftData);
        this.leftData = newVal;
        this.storageDateLeft = newVal;
      },
      immediate: true,
      deep: true
    },
    rightOption: {
      handler(newVal) {
        this.rightData = newVal;
        this.storageDateRight = newVal;
      },
      // immediate: true,
      // deep: true
    },
    // leftOption(val) {
    //   console.log('---leftData---', this.leftData);
    //   this.leftData = val;
    // },
    rightChecked() {
      this.$emit("getTransferResult", this.rightData);
    }
  },
  mounted() {
    
  },
  methods: {
    handleSearchLeft(e){
      console.log(e,456465465);
      if(e == ''){
        this.leftData = this.storageDateLeft;
        return;
      }  
      // 根据e实现对左边的数据过滤
      this.leftData = this.leftData.filter(item => {
        return item.brandName.includes(e) || item.goodsName.includes(e) || item.goodsBarcode.includes(e);
      });

    },
    handleSearchRight(e){
      console.log(e);
      console.log(this.rightData);
      if(e == ''){
        this.rightData = this.storageDateRight;
        return;
      }
      this.rightData = this.rightData.filter(item => {
        return item.brandName.includes(e) || item.goodsName.includes(e) || item.goodsBarcode.includes(e);
      });
    },
    handleLeftCheckAllChange(val) {
      // 选择左边的全选
      this.leftChecked = val ? this.leftData : [];
      this.leftIsIndeterminate = false;
    },
    handleLeftCheckedChange(value) {
      // 选择左边的checkbox
      let checkedCount = value.length;
      this.leftCheckAll = checkedCount === this.leftData.length;
      this.leftIsIndeterminate =
        checkedCount > 0 && checkedCount < this.leftData.length;
    },
    handleRightCheckAllChange(val) {
      // 选择右边的全选
      this.rightChecked = val ? this.rightData : [];
      this.rightIsIndeterminate = false;

      this.storageDateRight = this.rightData;
      this.$emit("getTransferResult", this.rightData);
    },
    handleRightCheckedChange(value) {
      // 选择右边的checkbox
      let checkedCount = value.length;
      this.rightCheckAll = checkedCount === this.rightData.length;
      this.rightIsIndeterminate =
        checkedCount > 0 && checkedCount < this.rightData.length;

      this.storageDateRight = this.rightData;
      this.$emit("getTransferResult", this.rightData);
    },
    allToRight() {
      // 移动所有到右边
      const result = this.checkCommon(this.leftData, this.rightData);
      if (!result) {
        if (this.showUseable) {
          this.leftData.forEach(v => {
            v.whitelistState = this.whitelistState;
          });
        }
        if (this.queryIsUsed) {
          this.rightData = this.leftData;
          this.rightData.forEach(v => {
            v.activityName = v.existActivity
              ? v.existActivity.map(item => item.promotionName)
              : [];
            v.activityStr = v.activityName.join(",");
            if (this.isMustDelivery) {
              v.isMustDelivery = this.isMustDelivery;
            }
          });
          this.leftData = [];
          this.leftChecked = [];
          this.handleRightCheckAllChange(true);
          this.leftCheckAll = false;
          this.rightCheckAll = true;
        } else {
          if (this.leftData.length > 0) {
            this.rightData = this.rightData.concat(this.leftData);
            this.rightData.forEach(v => {
              if (this.isMustDelivery) {
                v.isMustDelivery = this.isMustDelivery;
              }
            });
            this.leftData = [];
            this.leftChecked = [];
          }
          this.handleRightCheckAllChange(true);
          this.leftCheckAll = false;
          this.rightCheckAll = true;
        }
      }
      this.storageDateLeft = this.leftData;
      this.storageDateRight = this.rightData;
      this.$emit("getTransferResult", this.rightData);
    },
    toRight() {
      // 移动选中到右边
      console.log(this.leftChecked)
      console.log('***************')
      console.log(this.rightData)
      const result = this.checkCommon(this.leftChecked, this.rightData);

      if (!result) {
        if (this.showUseable) {
          this.leftData.forEach(v => {
            v.whitelistState = this.whitelistState;
          });
        }

        if (this.queryIsUsed) {
          this.rightData = this.rightData.concat(this.leftChecked);
          this.rightData.forEach(v => {
            v.activityName = v.existActivity
              ? v.existActivity.map(item => item.promotionName)
              : [];
            v.activityStr = v.activityName.join(",");
            if (this.isMustDelivery) {
              v.isMustDelivery = this.isMustDelivery;
            }
          });

        } else {
          this.rightData = this.rightData.concat(this.leftChecked);
          this.rightData.forEach(v => {
            if (this.isMustDelivery) {
              v.isMustDelivery = this.isMustDelivery;
            }
          });
        }
        if (this.leftChecked.length === this.leftData.length) {
          this.leftData = [];
        } else if (this.leftChecked.length === 1) {
          this.leftData.forEach((v, i) => {
            if (v[this.compareKey] === this.leftChecked[0][this.compareKey]) {
              this.leftData.splice(i, 1);
            }
          });
        } else {
          this.leftChecked.forEach(v => {
            this.leftData.forEach((item, index) => {
              if (v[this.compareKey] === item[this.compareKey]) {
                this.leftData.splice(index, 1);
              }
            });
          });
        }
        this.leftChecked = [];
        this.leftIsIndeterminate = false;
        this.leftCheckAll = false;
        this.handleRightCheckAllChange(true);
        this.rightCheckAll = true;
      }

      this.storageDateLeft = this.leftData;
      this.storageDateRight = this.rightData;
      this.$emit("getTransferResult", this.rightData);
    },
    allToLeft() {
      // 移动所有到左边
      this.rightCheckAll = false;
      this.rightIsIndeterminate = false;
      if (this.rightData.length > 0) {
        this.leftData = this.leftData.concat(this.rightData);
        this.leftData = arrayUnique2(this.leftData, this.compareKey);
        this.rightData = [];
        this.rightChecked = [];
      }
  
      this.leftData = this.leftData.concat(this.rightChecked);
      this.leftData = arrayUnique2(this.leftData, this.compareKey);
      if (this.rightChecked.length === this.rightData.length) {
        this.rightData = [];
        this.rightChecked = [];
        this.rightCheckAll = false;
      } else if (this.rightChecked.length === 1) {
        this.rightData.forEach((v, i) => {
          if (v[this.compareKey] === this.rightChecked[0][this.compareKey]) {
            this.rightData.splice(i, 1);
          }
        });
        this.rightChecked = [];
      } else {
        this.rightChecked.forEach(v => {
          this.rightData.forEach((item, index) => {
            if (v[this.compareKey] === item[this.compareKey]) {
              this.rightData.splice(index, 1);
            }
          });
        });
      }
      this.rightChecked = [];
      this.rightIsIndeterminate = false;

      this.storageDateLeft = this.leftData;
      this.storageDateRight = this.rightData;
      this.$emit("getTransferResult", this.rightData);
    },
    toLeft() {
      // 移动选中到左边
      this.leftData = this.leftData.concat(this.rightChecked);
      this.leftData = arrayUnique2(this.leftData, this.compareKey);
      if (this.rightChecked.length === this.rightData.length) {
        this.rightData = [];
        this.rightChecked = [];
        this.rightCheckAll = false;
      } else if (this.rightChecked.length === 1) {
        this.rightData.forEach((v, i) => {
          if (v[this.compareKey] === this.rightChecked[0][this.compareKey]) {
            this.rightData.splice(i, 1);
          }
        });
        this.rightChecked = [];
      } else {
        this.rightChecked.forEach(v => {
          this.rightData.forEach((item, index) => {
            if (v[this.compareKey] === item[this.compareKey]) {
              this.rightData.splice(index, 1);
            }
          });
        });
      }
      this.rightChecked = [];
      this.rightIsIndeterminate = false;

      this.storageDateLeft = this.leftData;
      this.storageDateRight = this.rightData;
      this.$emit("getTransferResult", this.rightData);
    },
    deleteChecked() {
      // 剔除右边和左边相同的
      if (this.leftChecked.length > 0) {
        this.leftChecked.forEach(v => {
          this.rightData.forEach((item, index) => {
            if (v.supplierGoodsId === item.supplierGoodsId) {
              this.rightData.splice(index, 1);
            }
          });
        });
        this.rightCheckAll = false;
      }
      this.$emit("getGuiderCount", this.rightChecked.length);
    },
    checkCommon(checkedData, data) {
      let result = false;
      checkedData.forEach(v => {
        data.forEach(item => {
          if (v[this.compareKey] === item[this.compareKey]) {
            this.$message({
              message: "请不要移动重复项",
              type: "warning"
            });
            result = true;
          }
        });
      });
      return result;
    }
  }
};
</script>

<style lang="scss" scoped>
.hm-transfer {
  border: none !important;
  .table-body {
    .check-wrapper {
      padding-left: 12px;
    }
    .el-checkbox {
      width: 100%;
    }

    .el-checkbox__label {
      width: calc(100% - 24px);
      display: flex;
    }
    .check-wrapper:nth-child(even) {
      background: #f7f7f7;
    }
  }
  .el-checkbox {
    margin-right: 0;
  }
}
.open-file {
  position: relative;
  overflow: hidden;
}
.open-file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
}
.tree-wrapper {
  width: 500px;
}
.transfer {
  border: 1px solid #e7e8ec;
  height: 485px;
  width: 500px;
  border-radius: 5px;
}
.transfer-header {
  padding: 1rem;
  background: #ecf2ff;
  border-radius: 5px 5px 0 0;
}
.table-out-header {
  position: relative;
}
.transfer-body {
  padding: 1rem;
  border-radius: 0 0 5px 5px;
  height: 403px;
  overflow-y: scroll;
}
.control {
  width: 130px;
  margin: 0 2rem;
  .el-button {
    margin: 0.5rem;
  }
}
.coupon-type,
.coupon-count,
.check-wrapper {
  padding: 12px;
  font-size: 14px;
}
.delete-selected {
  position: relative;
  .hmicon icon-wenhao {
    position: absolute;
    right: -7px;
    top: -7px;
    font-size: 1.2rem;
    color: #4680ff;
  }
}
.checkbox-group-wrapper {
  border-left: 1px solid #e7e8ec;
  border-right: 1px solid #e7e8ec;
  padding: 0 0.5rem;
}

input[type="number"] {
  width: 2rem;
  border: none;
  outline: none;
  text-align: center;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
.leftName,
.rightName {
  margin-left: -52px;
}

.error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
}

.minus,
.plus {
  transition: background 0.2s linear;
  cursor: pointer;
}
.disabled {
  color: rgb(220, 223, 230);
  cursor: not-allowed;
}

.divide {
  .divide-header {
    display: flex;
    display: -webkit-flex;
    padding-left: 24px;
    border-bottom: 1px solid #e7e8ec;
    padding-bottom: 1rem;
    color: #999;
    width: 100%;
    box-sizing: border-box;
    height: 30px;
    span {
      flex: 1;
      -webkit-flex: 1;
      padding-right: 0.5rem;
    }
  }
  .el-checkbox__label {
    span {
      flex: 1;
      -webkit-flex: 1;
      padding-right: 0.5rem;
    }
  }

  .check-wrapper {
    margin: 1rem 0;
  }
}

.transfer-body {
  .divide-header {
    display: flex;
    display: -webkit-flex;
    padding-left: 24px;
    border-bottom: 1px solid #e7e8ec;
    padding-bottom: 1rem;
    color: #999;
    width: 100%;
    box-sizing: border-box;
    height: 30px;
    .count {
      width: 56px;
    }
    .devide-type,
    .coupon-type,
    .coupon-target {
      display: flex;
      flex: 1;
      -webkit-flex: 1;
    }
    .coupon-name {
      display: flex;
      flex: 2;
      -webkit-flex: 2;
    }
    .coupon-name.flex1 {
      flex: 1;
      -webkit-flex: 1;
    }
    .devide-type {
      span {
        padding-right: 0.5rem;
      }
    }
  }
  .check-wrapper {
    margin: 1rem 0;
  }
  .devide-body {
    .devide-type,
    .coupon-type,
    .coupon-target {
      display: flex;
      flex: 1;
      -webkit-flex: 1;
    }
    .coupon-name {
      display: flex;
      flex: 2;
      -webkit-flex: 2;
    }
    .coupon-type {
      display: flex;
      align-items: center;
    }
  }
}
.table {
  margin: 20px 0;
  border: 1px solid #eaeaea;
  max-width: 600px;
  width: 500px;
  overflow: hidden;
  .delete {
    cursor: pointer;
    user-select: none;
  }
  .table-out-header,
  .no-message {
    padding: 12px;
  }
  .text-right{
    position:absolute;
    right:10px;
  }
  .table-header {
    padding: 12px;
    background: #f7f7f7;
    font-size: 12px;
    .num {
      margin-left: 26px;
    }
    .name {
      margin-left: -26px;
    }
  }
  .table-body {
    font-size: 12px;

    .ipt {
      -webkit-appearance: none;
      background-color: #fff;
      background-image: none;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      box-sizing: border-box;
      color: #606266;
      display: inline-block;
      font-size: inherit;
      outline: none;
      transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      width: 100%;
    }
    .row {
      padding: 12px;
      font-size: 12px;
    }
    .list-item:nth-child(even) {
      background: #f7f7f7;
    }
    .delete-icon {
      cursor: pointer;
      font-size: 12px;
    }
  }
  .goods-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 0 5px;
    box-sizing: border-box;
    width: 100px;
  }
}

.attrId {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 195px;
}

.tranfer-checkbox-wrapper {
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  .check-all {
    margin-left: 10px;
  }
}
</style>
